import { Box, Flex, Text } from "@chakra-ui/react";
import { BiChevronDown, BiChevronRight } from "react-icons/bi";
import colors from "core/resources/theme/colors";
import { useState } from "react";
import { Collapse } from "@chakra-ui/react";
import { PlanejamentoOrcamentarioDetalheItemResponse } from "core/features/previsao-orcamentaria/typings";
import { formatMoney } from "infra/helpers/number";
import ActionsKebabMenu from "components/ActionsKebabMenu/index";
import { MdEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";

interface CollapsePlanejamentoProps {
  item: PlanejamentoOrcamentarioDetalheItemResponse;
  nivel?: number;
  index?: number;
  handleDelete: (id: string) => Promise<void>;
  onEdit: (item: PlanejamentoOrcamentarioDetalheItemResponse) => void;
}

export default function CollapsePlanejamento({
  item,
  nivel = 0,
  index = 0,
  handleDelete,
  onEdit,
}: CollapsePlanejamentoProps) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((state) => !state);

  const hasItem = !!item.items.length;

  const getBg = () => {
    if (nivel === 0) {
      return colors.white;
    }
    if (hasItem) {
      return colors.blue100;
    }
    return index % 2 ? colors.white : colors.black75;
  };

  return (
    <Box w="100%">
      <Flex
        w="100%"
        h="50px"
        cursor="pointer"
        bg={getBg()}
        onClick={toggle}
        py={1}
        pr={6}
        pl={2}
        alignItems="center"
        roundedTop={nivel === 0 ? 6 : 0}
        mb="2px"
      >
        <Flex
          w="100%"
          alignItems="center"
          justify="space-between"
          pl={nivel * 5}
        >
          {item?.items.length ? (
            <Flex alignItems="center" h="40px" w="30px">
              {isOpen ? (
                <BiChevronDown size={25} color={colors.black700} />
              ) : (
                <BiChevronRight size={25} color={colors.black700} />
              )}
            </Flex>
          ) : null}
          <Flex
            w="100%"
            pl={hasItem ? 0 : "30px"}
            pr={!hasItem && nivel !== 0 ? " " : "55px"}
          >
            <Flex w="100%" justify="space-between" align="center">
              <Text>{`${item.breadcrumb} ${item.nome}`}</Text>
              {!isOpen || !hasItem ? (
                <Flex align="center" gap={4}>
                  <Text fontWeight="medium">
                    {formatMoney(hasItem ? item.previstoItems : item.previsto)}
                  </Text>
                  {!hasItem && nivel !== 0 ? (
                    <Flex h="fit-content">
                      <ActionsKebabMenu
                        indexItem={2}
                        item={item}
                        actions={[
                          {
                            title: "Editar",
                            icon: () => <MdEdit />,
                            onClick: (item) => {
                              onEdit(item);
                            },
                          },
                          {
                            title: "Excluir",
                            icon: () => <MdDelete />,

                            onClick: (item) => {
                              handleDelete(item.id);
                            },
                          },
                        ]}
                      />
                    </Flex>
                  ) : null}
                </Flex>
              ) : null}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      {hasItem ? (
        <>
          <Collapse in={isOpen}>
            {item?.items.map((item, index) => (
              <CollapsePlanejamento
                item={item}
                key={item.id}
                nivel={nivel + 1}
                index={index}
                onEdit={onEdit}
                handleDelete={handleDelete}
              />
            ))}
          </Collapse>
          {isOpen ? (
            <Flex
              align="center"
              bg={getBg()}
              h="50px"
              py={1}
              pr="80px"
              pl={2 + (nivel + 1) * 5}
              roundedBottom={nivel === 0 ? 6 : 0}
              justify="space-between"
            >
              <Text pl="30px" fontWeight="medium">
                Total
              </Text>
              <Text fontWeight={"medium"}>
                {formatMoney(item.previstoItems)}
              </Text>
            </Flex>
          ) : null}
        </>
      ) : null}
    </Box>
  );
}
